module.exports = __webpack_public_path__ + "static/img/step-4.5797166.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/local/step-4.svg
// module id = mO0p
// module chunks = 1